.vc-settings-modal-link-icon {
    height: 32px;
    width: 32px;
    border-radius: 50%;
    border: 4px solid var(--background-base-lowest);
    box-sizing: border-box
}

.vc-settings-modal-links {
    display: flex;
    gap: 0.2em;
}